"use client";

import * as Sentry from "@sentry/nextjs";
import Error from "next/error";
import React from "react";

export default function GlobalError({ error }: { error: any }) {
  React.useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <Error
          statusCode={error?.status_code || 500}
          title={error?.message}
        />
      </body>
    </html>
  );
}
